<template bindable="controller, errors, autofocus">
  <style>
    .validation-list {
      list-style: square inside;
      padding: 8px;
      border-radius: 6px;
      background: #fff0f0;
    }

    .validation-list a {
      color: darkred;
      text-decoration: none;
    }
  </style>

  <ul class="validation-list" show.bind="errors.length">
    <li repeat.for="error of errors">
      <a
        class="error-summary-list-link"
        href="#"
        external
        click.trigger="controller.elements.get(error)[0].focus()"
        if.bind="controller != null && autofocus"
      >
        <template replaceable part="error">${error.message}</template>
      </a>
      <span if.bind="!(controller != null && autofocus)">
        <template replaceable part="error">${error.message}</template>
      </span>
    </li>
  </ul>
</template>
